import { PatentImageServiceImpl } from './services/patent-images-service';
import { PatentImageService } from './services/patent-images-service.interface';
import { QueryPatentImagesServiceImpl } from './services/query-patent-images-service';
import { QueryPatentImagesService } from './services/query-patent-images-service.interface';
export function patentImageModule(bind) {
    bind(PatentImageService).to(PatentImageServiceImpl).inRequestScope();
    bind(QueryPatentImagesService).to(QueryPatentImagesServiceImpl);
}
